var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Gadget } from '../libs/gadgets.class';
var SimpleSelect = /** @class */ (function (_super) {
    __extends(SimpleSelect, _super);
    function SimpleSelect(id, options) {
        var _this = _super.call(this) || this;
        _this.disabled = false;
        _this.id = id;
        _this.options = options;
        return _this;
    }
    SimpleSelect.prototype.Select = function (name) {
        this.selected = name;
    };
    SimpleSelect.prototype.disable = function () {
        this.disabled = true;
    };
    SimpleSelect.prototype.enable = function () {
        this.disabled = false;
    };
    SimpleSelect.prototype.onChange = function (fn) {
        var _this = this;
        $('#' + this.id).on('change', function (val) {
            fn($('#' + _this.id).val());
        });
    };
    SimpleSelect.prototype.render = function (forceParseGadgets) {
        var _this = this;
        this.parseGadgets();
        var options = "";
        var _ds = this.disabled ? "disabled" : "";
        this.options.forEach(function (e) {
            if (Array.isArray(e)) {
                if (_this.selected && _this.selected == e[0])
                    options += "<option value=\"".concat(e[1], "\" selected>").concat(e[0], "</option>");
                else
                    options += "<option value=\"".concat(e[1], "\">").concat(e[0], "</option>");
            }
            else {
                if (_this.selected && _this.selected == e)
                    options += "<option selected>".concat(e[0], "</option>");
                else
                    options += "<option>".concat(e, "</option>");
            }
        });
        return "<select id=\"".concat(this.id, "\" class=\"form-select form-select-sm\" ").concat(_ds, ">").concat(options, "</select>");
    };
    return SimpleSelect;
}(Gadget));
export { SimpleSelect };
